const merge = require('lodash/merge');
const { apiPortfolioId } = require('../../utils');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const { Base64 } = require('js-base64');
const apiConfig = require('../../api-config');

function apiFactory({
  baseUrl,
  requestHandler
}) {
  const headers = {
    Accept: 'application/json'
  };

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {
    initializeEDelivery(inputParam, metaData) {

      const url = getUrl('initializeEDelivery');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const params = inputParam.split('#@#');
      const decodedpfIdParam = Base64.decode(params[0]);
      const pfIdStringArray = decodedpfIdParam.split('$');
      // const pfIdNumberArray = pfIdStringArray.map(Number);WMCE-7858 commented to accomodate alphanumeric PF id
      const channel = params[1];
      const fromRecievedDate = params[2];
      const toRecievedDate = params[3];
      const allPortfolios = params[4];
      const branchCode = parsedMetaData.portfolio.branchCode === 999999999? parsedMetaData.configBranchCode : parsedMetaData.portfolio.branchCode;
      const body = {
        portfolioIds: pfIdStringArray,
        userId: parsedMetaData.qs.userId,
        branchCode: branchCode,
        fromRecievedDate: fromRecievedDate,
        toRecievedDate: toRecievedDate,
        language: parsedMetaData.portfolio.language,
        channel: channel,
        allPortfolios: allPortfolios,
      };

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    },

    handleDocuments(documentIds, action, metaData) {

      const url = getUrl('handleDocuments');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };

      const branchCode = parsedMetaData.portfolio.branchCode === 999999999? parsedMetaData.configBranchCode : parsedMetaData.portfolio.branchCode;
      const body = {
        documentIds: documentIds,
        action: action,
        userId: parsedMetaData.qs.userId,
        branchCode: branchCode,
        language: parsedMetaData.portfolio.language,
        channel: parsedMetaData.channel,
      };

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    },

    markDocumentsAsRead(inputParam, metaData) {

      const url = getUrl('markDocumentsAsRead');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const params = inputParam.split('#@#');
      const decodedDocIdParam = Base64.decode(params[0]);
      const documentIdStringArray = decodedDocIdParam.split('$');
      // const documentIdIntArray = documentIdStringArray.map(Number);WMCE-7858 commented to accomodate alphanumeric PF id
      const channel = params[1];
      const branchCode = parsedMetaData.portfolio.branchCode === 999999999? parsedMetaData.configBranchCode : parsedMetaData.portfolio.branchCode;
      const body = {
        documentIds: documentIdStringArray,
        userId: parsedMetaData.qs.userId,
        branchCode: branchCode,
        language: parsedMetaData.portfolio.language,
        channel: channel,
      };

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    },

    downloadDocuments(inputParam, metaData) {
      const url = getUrl('downloadDocuments');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const params = inputParam.split('#@#');
      const channel = params[0];
      const decodedDocIdParam = Base64.decode(params[1]);
      const documentIdStringArray = decodedDocIdParam.split('$');
      const documentIdIntArray = documentIdStringArray.map(Number);
      const branchCode = parsedMetaData.portfolio.branchCode === 999999999? parsedMetaData.configBranchCode : parsedMetaData.portfolio.branchCode;
      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: branchCode,
        channel: channel,
        language: parsedMetaData.portfolio.language,
        documentIds: documentIdIntArray,

      };

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    },

    fetchDocumentsForCategories(inputParam, metaData) {

      const url = getUrl('fetchDocumentsForCategories');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const params = inputParam.split('#@#');
      const branchCode = parsedMetaData.portfolio.branchCode === 999999999? parsedMetaData.configBranchCode : parsedMetaData.portfolio.branchCode;
      const channel = params[0];

      const decodedpfIdParam = Base64.decode(params[1]);
      const pfIdStringArray = decodedpfIdParam.split('$');
      // const pfIdNumberArray = pfIdStringArray.map(Number); WMCE-7858 commented to accomodate alphanumeric PF id

      const decodedMailBoxIdParam = Base64.decode(params[2]);
      const mailBoxStringArray = decodedMailBoxIdParam.split('$');
      const mailBoxNumberArray = mailBoxStringArray.map(Number);

      const decodedcategoryIdParam = Base64.decode(params[3]);
      const categoryIdStringArray = decodedcategoryIdParam.split('$');
      const categoryIdNumberArray = categoryIdStringArray.map(Number);

      const fromRecievedDate = params[4];
      const toRecievedDate = params[5];
      const allPortfolios = params[6];

      const body = {
        userId: parsedMetaData.qs.userId,
        language: parsedMetaData.portfolio.language,
        channel: channel,
        branchCode: branchCode,
        portfolioIds: pfIdStringArray,
        mailBoxIds: mailBoxNumberArray,
        categoryIds: categoryIdNumberArray,
        fromRecievedDate: fromRecievedDate,
        toRecievedDate: toRecievedDate,
        allPortfolios: allPortfolios,
      };

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    },

    fetchDocumentsForOrder(inputParam, metaData) {

      const url = getUrl('fetchDocumentsForOrder');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const params = inputParam.split('#@#');
      const branchCode = parsedMetaData.portfolio.branchCode === 999999999? parsedMetaData.configBranchCode : parsedMetaData.portfolio.branchCode;
      const channel = params[0];
      const posId = params[1];
      const transactioDate = params[2];
      const orderNumber = params[3];

      const body = {
        userId: parsedMetaData.qs.userId,
        language: parsedMetaData.portfolio.language,
        channel: channel,
        branchCode: branchCode,
        posId: posId,
        transactioDate: transactioDate,
        orderNumber: orderNumber,
      };

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    },

    // used only in trading (only for App)
    fetchDocuments(inputParam, metaData) {
      const url = getUrl('documents/orders/categories/fetch');
      console.log("url"+url);
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const params = inputParam.split('#@#');
      const orderId = Base64.decode(params[0]) || [];
      const orderIdStringArray = orderId.split('$');

      const categoryIds = Base64.decode(params[1]) || [];
      const categoryIdsStringArray = categoryIds.split('$');
      const channel = params[2];

      const body = {
        orderIds: orderIdStringArray,
        categoryIds: categoryIdsStringArray,
        channel: channel,
        language: parsedMetaData.portfolio.language,
        branchCode: apiConfig.branchCode,
        userId: parsedMetaData.qs.userId
      }
      console.log("fetchDocuments: " + body)
      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    },

    getStatementTypes(metaData) {

      const url = getUrl('reports/statement-types/fetch');
      const parsedMetaData = parseRequestMetaData(metaData);
        const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };

      const body ={
        userId: parsedMetaData.qs.userId
      }
  
      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    },

    createAdhocStatementReport(inputParam, metaData) {
      const url = getUrl('documents/reports/adhoc/create');

      const parsedMetaData = parseRequestMetaData(metaData);
      
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const params = inputParam.split('#@#');

      const channel = params[0];

      const body ={
        [ params[5] === 'true' ? 'accountId' : 'portfolioId' ] : params[1],
        branchCode: parsedMetaData.portfolio.branchCode,
        channel:channel,
        reportTypeId: params[4],
        reportDurationFrom: params[2],
        reportDurationTo: params[3],
        language: parsedMetaData.portfolio.language,
        userId: parsedMetaData.qs.userId
      }

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    }
  };
}

module.exports = apiFactory;
